<template>
	<div class="section">
		<div class="profile_page">
			<b-overlay :show="isLoading">
				<div v-if="!success">
					<h1 class="text-xs-center">Восстановление</h1>
					<b-form-group label="Логин:">
						<b-form-input v-model="$v.uid.$model" placeholder="Введите логин" :state="validateUid()" autocomplete="off"></b-form-input>
						<b-form-invalid-feedback>Поле обязательно для заполнения</b-form-invalid-feedback>
					</b-form-group>
					<b-form-group>
						<vue-recaptcha v-bind:sitekey="key" @verify="recaptchaVerify" @expired="recaptchaExpired" ref="recaptcha_box"></vue-recaptcha>
					</b-form-group>
					<div class="error" v-if="send">Не удалось отправить письмо</div>
					<div v-if="errors.length > 0">
						<div class="error" v-for="(error, index) in errors" :key="index">{{ error }}</div>
					</div>			
					<b-button variant="primary" v-on:click="sendForgotPassword" onclick="this.blur();" style="float: right;">Восстановить</b-button>
				</div>
				<div v-else class="success">
					<h5>Мы отправили вам письмо</h5>
					<h5>для восстановления пароля</h5>
				</div>
			</b-overlay>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import { FORGOT_PASSWORD } from '@/store/actions.type'
import { required, } from 'vuelidate/lib/validators'

export default {
	name: 'ForgotPassword',
	validations: {
		uid: {
			required
		}
	},
	components: {
		VueRecaptcha
	},
	data () {
		return {
			uid: '',
			token: '',
			responce: '',
			key: process.env.RECAPTCHA_KEY,
			success: '',
			send: false
		}
	},
	computed: {
		...mapGetters({
			isLoading: 'forgotPasswordIsLoading',
			errors: 'forgotPasswordErrors'
		}),
	},
	methods: {
		recaptchaVerify (response) {
			this.token = response
		},
		recaptchaExpired () {
			this.token = ''
		},
		sendForgotPassword () {
			this.$v.uid.$touch()
			if (this.$v.uid.$anyError || !(this.token && this.token.length > 0)) {
				this.$refs.recaptcha_box.reset()
				this.token = ''
				return
			}

			this.$store.dispatch(FORGOT_PASSWORD, { uid: this.uid, token: this.token })
			.then((data) => {
				this.send = true
				this.success = data === true ? true : false
			})

			this.$refs.recaptcha_box.reset()
			this.token = ''
		},
		validateUid() {
			const { $dirty, $error } = this.$v.uid
			return $dirty ? !$error : null
		}

	}
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/Profile/ForgotPassword.vue